import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withModifiers as _withModifiers, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Teleport as _Teleport } from "vue"
import _imports_0 from '@/assets/images/logo.png'
import _imports_1 from '@/assets/images/form/line.png'
import _imports_2 from '@/assets/images/form/ico-arrow.svg'


const _hoisted_1 = { class: "Form" }
const _hoisted_2 = {
  key: 0,
  class: "Form-inner"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "LogoSmall" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "line-head" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: ""
  })
], -1)
const _hoisted_5 = { class: "form_contain" }
const _hoisted_6 = { class: "quiz1" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "quiz-title" }, " 1. อธิษฐานยังงัยให้ได้ golden card ", -1)
const _hoisted_8 = { class: "quiz1-ans" }
const _hoisted_9 = { class: "quiz2" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "quiz-title" }, "2. กรอกข้อมูลส่วนตัวให้ครบถ้วน", -1)
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = { class: "form-group" }
const _hoisted_13 = { class: "form-group" }
const _hoisted_14 = { class: "bt_group" }
const _hoisted_15 = { class: "bt_group_inner" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "ico-arrow" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: ""
  })
], -1)
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" ส่งข้อมูลเพื่อลุ้นรับรางวัล ")
const _hoisted_18 = [
  _hoisted_16,
  _hoisted_17
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_PopupAlert = _resolveComponent("PopupAlert")!
  const _component_PopupCookie = _resolveComponent("PopupCookie")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.ShowCookies)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_a_form, {
              model: _ctx.FormState,
              rules: _ctx.rules,
              name: "basic",
              "label-col": { span: 32 },
              "wrapper-col": { span: 32 },
              autocomplete: "off",
              onFinish: _ctx.onFinish,
              onFinishFailed: _ctx.onFinishFailed
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  _hoisted_7,
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_a_form_item, {
                      label: "",
                      name: "message"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_textarea, {
                          value: _ctx.FormState.message,
                          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.FormState.message) = $event)),
                          showCount: "",
                          maxlength: 250,
                          placeholder: "พิมพ์คำตอบให้ปังที่สุด...",
                          "auto-size": { minRows: 5, maxRows: 5 }
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_a_form_item, {
                      label: "",
                      name: "firstname"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: _ctx.FormState.firstname,
                          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.FormState.firstname) = $event)),
                          placeholder: "กรอกชื่อ",
                          maxlength: 50,
                          class: "forminput"
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_component_a_form_item, {
                      label: "",
                      name: "lastname"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: _ctx.FormState.lastname,
                          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.FormState.lastname) = $event)),
                          placeholder: "กรอกนามสกุล",
                          maxlength: 50,
                          class: "forminput"
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createVNode(_component_a_form_item, {
                      label: "",
                      name: "mobile"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: _ctx.FormState.mobile,
                          "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.FormState.mobile) = $event)),
                          onPaste: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"])),
                          type: 'tel',
                          onKeypress: _cache[5] || (_cache[5] = ($event: any) => (_ctx.isNumber($event))),
                          placeholder: "กรอกเบอร์มือถือ",
                          maxlength: 10,
                          class: "forminput"
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", {
                  class: "bt-showterm",
                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.ShowPopupCookie && _ctx.ShowPopupCookie(...args)))
                }, " อ่านกติกาเพิ่มสำหรับการรับรางวัล "),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("button", {
                      class: _normalizeClass(["bt-content", {'active':_ctx.btActive}]),
                      type: "submit"
                    }, _hoisted_18, 2)
                  ])
                ])
              ]),
              _: 1
            }, 8, ["model", "rules", "onFinish", "onFinishFailed"])
          ])
        ]))
      : _createCommentVNode("", true),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (_ctx.IsFull)
        ? (_openBlock(), _createBlock(_component_PopupAlert, { key: 0 }))
        : _createCommentVNode("", true)
    ])),
    (_openBlock(), _createBlock(_Teleport, { to: "#app" }, [
      (_ctx.ShowCookies)
        ? (_openBlock(), _createBlock(_component_PopupCookie, { key: 0 }))
        : _createCommentVNode("", true)
    ]))
  ]))
}